import { render, staticRenderFns } from "./ActionModal.vue?vue&type=template&id=830d0778&"
import script from "./ActionModal.vue?vue&type=script&lang=js&"
export * from "./ActionModal.vue?vue&type=script&lang=js&"
import style0 from "./ActionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../locales/actionModal.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fsrc%2Fcomponents%2FActionModal.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports